<template>
    <div class="copiar_matriz">
        <div class="box-body bg-light matriz-peligro-content m-3">
            <h3 class="mt-3" style="text-align: center !important; color: #878787; font-size: 20px; font-weight: bold;">
                DATOS DE LA MATRIZ A COPIAR
            </h3>
            <hr />
            <div class="row m-1">
                <div class="col-md-4 text-left">
                    <label class="mt-3">Nombre de la Empresa: <b>{{ empresa.nombre }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Actividad Económica: <b>{{ empresa.actividad }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Nombre del Centro de Trabajo: <b>{{ empresa.centroTrabajo }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Ciudad: <b>{{ empresa.ubicacion.ciudad }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Departamento: <b>{{ empresa.ubicacion.departamento }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Número de Trabajadores: <b>{{ empresa.numeroTrabajadores }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Clase de Riesgo:</label>
                    <div v-if="empresa.claseRiesgo">
                        <div v-for="(item, index) of empresa.claseRiesgo" :key="index">
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Fecha Actualización: <b>{{ empresa.fechaActualizacion }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Responsable Empresa: <b>{{ empresa.responsable }}</b></label>
                </div>
                <div class="col-md-4 text-left">
                    <label class="mt-3">Visita Atendida Por: <b>{{ empresa.visita }}</b></label>
                </div>
            </div>
        </div>
        <div class="box-body bg-light matriz-peligro-content m-3">
            <h3 class="mt-3" style="text-align: center !important; color: #878787; font-size: 20px; font-weight: bold;">
                DATOS DEL NUEVO CENTRO DE TRABAJO
            </h3>
            <hr />
            <div class="col-md-12">
                <form v-on:submit.prevent="agregarCentroTrabajo()">
                    <div class="row justify-content-center">
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Cliente: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Seleccione uno de los clientes con el que vinculará la matriz de peligros"></i></span></label>
                            <v-select class="form-control form-control-sm boton_texto mt-5" v-model="copia.cliente.nombre"
                                @input="obtenerCliente()" :options="clientes" required></v-select>
                        </div>
                        <div class="col-md-4">
                            <label class="color_letra mt-3">Grupo de Exposición Similar: *<span
                                    class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="El grupo de exposición similar es la agrupación de los clientes de acuerdo a su actividad económica principal"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="copia.cliente.sector"
                                type="text" required disabled />
                        </div>
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Nombre del Centro de Trabajo: *<span
                                    class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="Indique el nombre del Centro de Trabajo al que va a realizar la matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="copia.cliente.centroTrabajo"
                                type="text" placeholder="Nombre del Centro de Trabajo" required />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Expuestos: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Indique a continuación el número de trabajadores objeto de la presente matriz de peligros, incluir trabajadores que están en descanso y/u otros turnos"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="copia.cliente.numeroExpuestos"
                                type="number" min="0" placeholder="N° de Expuestos" required />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Regional: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Seleccione a continuación la regional a la que pertenece el Centro de Trabajo"></i></span></label>
                            <select class="form-control form-control-sm boton_texto"
                                v-model="copia.cliente.ubicacion.regional" @change="obtenerDepartamentos()" id="regional"
                                required>
                                <option value="" selected disabled>
                                    Seleccione la regional
                                </option>
                                <option v-for="(regional, index) of regionales" :key="index">
                                    {{ regional }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Departamento: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Seleccione a continuación el departamento al que pertenece el Centro de Trabajo"></i></span></label>
                            <select class="form-control form-control-sm boton_texto"
                                v-model="copia.cliente.ubicacion.departamento" @change="obtenerMunicipios()"
                                id="departamento" required>
                                <option value="" selected disabled>
                                    Seleccione el departamento
                                </option>
                                <option v-for="(departamento, index) of departamentos" :key="index">
                                    {{ departamento }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Ciudad/Municipio: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Seleccione a continuación la ciudad o muncipio al que pertencece el Centro de Trabajo"></i></span></label>
                            <select class="form-control form-control-sm boton_texto" id="ciudad"
                                v-model="copia.cliente.ubicacion.municipio" required>
                                <option value="" selected disabled>
                                    Seleccione la ciudad
                                </option>
                                <option v-for="(municipio, index) of municipios" :key="index">
                                    {{ municipio }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Dirección:
                                <span class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="Relaciona a continuación la dirección donde se ubica el Centro de Trabajo"></i></span></label>
                            <input class="form-control form-control-sm boton_texto"
                                v-model="copia.cliente.ubicacion.direccion" type="text" min="1"
                                placeholder="Dirección del centro de trabajo" />
                        </div>
                        <div class="col-md-4 col-12 form-group">
                            <label class="color_letra mt-3"><b>Ubicación GPS de la Residencia Actual</b></label>
                            <br />
                            <div class="row">
                                <div class="col-sm-2">
                                    <button class="btn gps btn-sm mb-1" type="button" @click="obtenerCoordenadas()">
                                        Obtener
                                    </button>
                                </div>
                                <div class="col-sm-10">
                                    <input class="form-control form-control-sm form-control form-control-sm-sm boton_texto"
                                        v-model="copia.cliente.ubicacion.coordenadas" type="text" readonly required />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Contacto del centro de trabajo: *<span
                                    class="badge text-secondary"><i class="fas fa-question-circle fa-lg"
                                        data-toggle="tooltip" data-placement="right" data-html="true"
                                        title="Relaciona a continuación la persona contacto o representante de la empresa en el Centro de Trabajo con quien se coordinó la actividad de la matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="copia.cliente.contacto.nombre"
                                type="text" placeholder="Nombre de la persona" required readonly />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Cargo: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Relacione a continuación el cargo de la persona contacto con quien se coordinó la actividad de la matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="copia.cliente.contacto.cargo"
                                type="text" placeholder="Cargo de la persona" onchange="value=toTitleCase(this.value)"
                                onkeyup="value=toTitleCase(this.value)" required readonly />
                        </div>
                        <div class="col-md-3">
                            <label class="color_letra mt-3">Correo Electrónico: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Relacione a continuación el correo del contacto del centro de trabajo con quien se coordinó la actividad de matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto" v-model="copia.cliente.contacto.correo"
                                type="email" placeholder="Correo electrónico" required readonly />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Celular/Teléfono: *<span class="badge text-secondary"><i
                                        class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right"
                                        data-html="true"
                                        title="Relacione a continuación un numero telefónico del contacto del centro de trabajo con quien se coordino la actividad de matriz de peligros"></i></span></label>
                            <input class="form-control form-control-sm boton_texto"
                                v-model="copia.cliente.contacto.telefono" type="number" min="1"
                                placeholder="Celular o teléfono" required readonly />
                        </div>
                        <div class="col-md-2">
                            <label class="color_letra mt-3">Fecha Matriz:
                                <a class="btn btn-sm btn-form font-weight-bold" data-toggle="modal"
                                    data-target="#controlCambios" type="button">
                                    <i class="fas fa-calendar-alt"></i>
                                </a>
                            </label>
                        </div>
                    </div>
                    <br />
                    <div class="col-md-6">
                        <label class="color_letra mt-3">* Campos Obligatorios.</label>
                    </div>
                    <div class="row justify-content-center">
                        <button class="btn btn-sm btn-form font-weight-bold" type="submit" style="width: 200px;"
                            :disabled="!$store.state.global_privilegio_matriz_peligro.crear">
                            COPIAR
                        </button>
                        <router-link to="/lista_clientes" class="btn btn-dark btn-sm rounded-pill font-weight-bold"
                            type="button" style="width: 200px;">
                            CANCELAR
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
        <!-- MODAL CONTROL DE CAMBIOS -->
        <div class="modal fade" id="controlCambios" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-light">
                    <div class="modal-header">
                        <h5 class="modal-title dato" id="exampleModalLabel">
                            Control de Cambios
                        </h5>
                        <button class="close" data-dismiss="modal" type="button" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label class="color_letra mb-4">Tipo de Cambio: * </label>
                                <select class="form-control form-control-sm boton_texto mt-4"
                                    v-model="controlCambioMatriz.controlCambios.tipoCambio">
                                    <option disabled selected>Seleccione...</option>
                                    <option value="Elaboración">Elaboración</option>
                                    <option value="Actualizacción">Actualizacción</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="color_letra mb-4">Fecha: * </label>
                                <input class="form-control form-control-sm boton_texto" v-model="fechaCambio" type="date" />
                            </div>
                            <div class="col-md-6">
                                <label class="color_letra">Observación:</label>
                                <textarea class="form-control form-control-sm boton_texto" v-model="
                                    controlCambioMatriz.controlCambios.observacionCambio
                                " placeholder="Observación." autocomplete="on"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-center">
                        <button class="btn btn-sm btn-form font-weight-bold" data-dismiss="modal" type="button">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <ObtenerMatriz :id="id" @matriz="obtenerMatriz" />
    </div>
</template>

<script>
import { db, firebase } from '@/firebase';
import Swal from 'sweetalert2';
import ObtenerMatriz from '../../components/MatrizPeligros/Acciones/ObtenerMatriz.vue';
export default {
    name: "copiar_matriz",

    components: {
        ObtenerMatriz
    },

    data() {
        return {
            id: this.$route.params.id,
            clientes: [],
            regionales: [],
            departamentos: [],
            municipios: [],
            copia: {
                cliente: {
                    id: "",
                    nombre: "",
                    sector: "",
                    centroTrabajo: "",
                    numeroExpuestos: "",
                    ubicacion: {
                        regional: "",
                        pais: "Colombia",
                        departamento: "",
                        municipio: "",
                        direccion: "",
                        coordenadas: "",
                    },
                    contacto: {
                        nombre: "Ángela Johana Gaitán López",
                        cargo: "Gerente H&S",
                        correo: "angela.gaitan@co.g4s.com",
                        telefono: 3212543320
                    }
                },
            },
            controlCambioMatriz: {
                controlCambios: {
                    idControlCambio: "",
                    tipoCambio: "",
                    fechaCambio: "",
                    observacionCambio: "",
                    correoUsuario: this.$store.state.email_session,
                },
                registro: {
                    creacion: firebase.firestore.FieldValue.serverTimestamp(),
                },
            },
            empresa: {
                nombre: "",
                sector: "",
                actividad: "",
                claseRiesgo: [],
                nit: "",
                centroTrabajo: "",
                ubicacion: {
                    pais: "",
                    departamento: "",
                    ciudad: "",
                },
                numeroTrabajadores: "",
                fechaActualizacion: "",
                responsable: "",
                esBaja: null,
                visita: "",
                evaluacion: "",
            },
            matriz: [],
            fechaCambio: ""
        }
    },

    watch: {
        $route(to) {
            this.id = to.params.id;
        },
    },

    async created() {
        if (!this.$store.state.global_privilegio_matriz_peligro.copiar_matriz) {
            this.$router.replace("/lista_clientes");
        } else {
            $(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });
            if (!this.$store.state.email) {
                this.$router.replace("/");
                return;
            }
            await this.obtenerClientes();
            await this.obtenerRegionales();
        }
    },

    methods: {
        async obtenerClientes() {
            this.clientes = [];
            await db.collection("cliente_principal").where("cl_estado", "==", "En Servicio").orderBy("cl_cliente").get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    this.clientes.push(doc.data().cl_cliente);
                });
            });
            let set = new Set(this.clientes.map(JSON.stringify));
            this.clientes = Array.from(set).map(JSON.parse);
        },

        async obtenerCliente() {
            await db.collection("cliente_principal").where("cl_cliente", "==", this.copia.cliente.nombre).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    this.copia.cliente.id = doc.id;
                    this.copia.cliente.sector = doc.data().cl_sector;
                });
            })
        },

        async obtenerRegionales() {
            if (this.$store.state.global_privilegio_regionales_todas) {
                await db.collection("nuevo_regional").where("r_registrado_por", "==", this.$store.state.email).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        this.regionales.push(doc.data().r_nueva_region);
                    });
                });
                let set = new Set(this.regionales.map(JSON.stringify));
                this.regionales = Array.from(set).map(JSON.parse);
            } else {
                this.$store.state.global_privilegio_regional.forEach((x) => {
                    this.regionales.push(x.nombre_regional);
                });
                let set = new Set(this.regionales.map(JSON.stringify));
                this.regionales = Array.from(set).map(JSON.parse);
            }
        },

        async obtenerDepartamentos() {
            this.departamentos = [];
            this.municipios = [];
            if (this.$store.state.global_privilegio_regionales_todas) {
                await db.collection("nuevo_regional")
                    .where("r_nueva_region", "==", this.copia.cliente.ubicacion.regional)
                    .where("r_registrado_por", "==", this.$store.state.email)
                    .orderBy("r_departamento", "asc")
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            this.departamentos.push(doc.data().r_departamento);
                        });
                    });
                let set = new Set(this.departamentos.map(JSON.stringify));
                this.departamentos = Array.from(set).map(JSON.parse);
            } else {
                this.$store.state.global_privilegio_regional.forEach((x) => {
                    if (x.nombre_regional == this.copia.cliente.ubicacion.regional) {
                        x.departamentos.forEach((y) => {
                            this.departamentos.push(y.nombre_departamento);
                        });
                    }
                });
                let set = new Set(this.departamentos.map(JSON.stringify));
                this.departamentos = Array.from(set).map(JSON.parse);
            }
        },

        async obtenerMunicipios() {
            this.municipios = [];
            if (this.$store.state.global_privilegio_regionales_todas) {
                await db.collection("nuevo_regional")
                    .where("r_nueva_region", "==", this.copia.cliente.ubicacion.regional)
                    .where("r_departamento", "==", this.copia.cliente.ubicacion.departamento)
                    .where("r_registrado_por", "==", this.$store.state.email)
                    .get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            this.municipios = doc.data().r_municipios;
                        });
                    });
                let set = new Set(this.municipios.map(JSON.stringify));
                this.municipios = Array.from(set).map(JSON.parse);
            } else {
                this.$store.state.global_privilegio_regional.forEach((x) => {
                    if (x.nombre_regional == this.copia.cliente.ubicacion.regional) {
                        x.departamentos.forEach((y) => {
                            if (y.nombre_departamento == this.copia.cliente.ubicacion.departamento) {
                                this.municipios = y.municipios;
                            }
                        });
                    }
                });
                let set = new Set(this.municipios.map(JSON.stringify));
                this.municipios = Array.from(set).map(JSON.parse);
            }
        },

        obtenerCoordenadas() {
            this.copia.cliente.ubicacion.coordenadas = "";
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.copia.cliente.ubicacion.coordenadas = position.coords.latitude + ", " + position.coords.longitude;
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        background: "transparent",
                        html: '<h4 style="color: rgb(255, 255, 255)">¡Ubicación obtenida correctamente!</h4>',
                        backdrop: `rgba(0,0,0,0.8)`,
                        showConfirmButton: false,
                        timer: 1500,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    });
                });
            } else {
                console.log("¡El navegador no soporta la geolocalización!");
            }
        },

        async obtenerMatriz(data) {
            this.empresa = data.empresa;
            this.matriz = data.matriz;
        },

        async agregarCentroTrabajo() {
            if (this.$store.state.global_privilegio_matriz_peligro.crear) {
                if (!this.fechaCambio) {
                    Swal.fire({
                        position: "center",
                        icon: "warning",
                        title: "¡Fecha matriz vacía!",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "Entendido",
                    });
                } else if (!this.copia.cliente.nombre) {
                    Swal.fire({
                        position: "center",
                        icon: "warning",
                        title: "¡Cliente vacío!",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "Entendido",
                    });
                } else {
                    this.$isLoading(true);
                    this.fechaCambio = this.fechaCambio.split("-");
                    let newDate = new Date(
                        this.fechaCambio[0],
                        this.fechaCambio[1] - 1,
                        this.fechaCambio[2]
                    );
                    this.controlCambioMatriz.controlCambios.fechaCambio = newDate;
                    let newCentroRef = db.collection("cliente_empresa").doc();
                    let idCliente = newCentroRef.id;
                    await db.collection("cliente_empresa").doc(idCliente).set({
                        em_baja: true,
                        em_activo: true,
                        em_cargo: this.copia.cliente.contacto.cargo,
                        em_ciudad: this.copia.cliente.ubicacion.municipio,
                        em_completo: true,
                        em_correo_contacto: this.copia.cliente.contacto.correo,
                        em_departamento: this.copia.cliente.ubicacion.departamento,
                        em_direccion: this.copia.cliente.ubicacion.direccion,
                        em_empresa: "G4S",
                        em_fecha: firebase.firestore.FieldValue.serverTimestamp(),
                        em_fecha_editado: newDate,
                        em_gps: this.copia.cliente.ubicacion.coordenadas,
                        em_id_cliente_principal: this.copia.cliente.id,
                        em_nit: "",
                        em_num_trabajadores: this.copia.cliente.numeroExpuestos,
                        em_numero_contacto: this.copia.cliente.contacto.telefono,
                        em_pais: this.copia.cliente.ubicacion.pais,
                        em_regional: this.copia.cliente.ubicacion.regional,
                        em_registrado_por: this.$store.state.email_session,
                        em_responsable: this.copia.cliente.contacto.nombre,
                        em_sector: this.copia.cliente.sector,
                        em_trabajo: this.copia.cliente.centroTrabajo,
                        em_visita: this.$store.state.email_session,
                    })
                    this.$store.state.n_max_expuestos = this.copia.cliente.numeroExpuestos;
                    this.$store.state.msp_c_key = idCliente;
                    this.$store.state.msp_c_key_cliente_iper = this.copia.cliente.id;
                    await this.registrarControlCambio(idCliente);
                    await this.copiarMatriz();
                }
            }
        },

        async copiarMatriz() {
            if (this.$store.state.msp_c_key && this.$store.state.msp_c_key_cliente_iper) {
                let copiaMatriz = JSON.parse(JSON.stringify(this.matriz));
                let procesos = await Promise.all(copiaMatriz.map(async (item) => {
                    return await this.registrarProceso(item);
                }));
                await Promise.all(procesos.map(async (item) => {
                    return await this.registrarPeligros(item)
                }));
                this.$store.state.n_max_expuestos = "";
                this.$store.state.msp_c_key = "";
                this.$store.state.msp_c_key_cliente_iper = "";
                this.$isLoading(false);
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "¡Matriz copiada!",
                    text: "La matriz ha sido copiada correctamente",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: "Entendido",
                }).then((result) => {
                    if (result.value) {
                        this.$router.replace("/lista_clientes")
                    }
                });
            }
        },

        async registrarProceso(item) {
            const newProcesoRef = db.collection("proceso").doc();
            const id_proceso = newProcesoRef.id;

            const newZonaRef = db.collection("zona").doc();
            const id_zona = newZonaRef.id;

            const newActividadRef = db.collection("actividades").doc();
            const id_acti = newActividadRef.id;

            const newTareaRef = db.collection("tareas").doc();
            const id_tarea = newTareaRef.id;

            await db.collection("proceso").doc(id_proceso).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_proceso_riesgo: item.proceso_riesgo,
            });
            await db.collection("zona").doc(id_zona).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_proceso: id_proceso,
                em_zona: item.zona,
            });
            await db.collection("actividades").doc(id_acti).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_proceso: id_proceso,
                em_id_zona: id_zona,
                em_actividades: item.actividades,
            });
            await db.collection("tareas").doc(id_tarea).set({
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_proceso: id_proceso,
                em_id_zona: id_zona,
                em_id_acti: id_acti,
                em_tareas: item.tareas,
            });

            return {
                id_proceso: id_proceso,
                id_zona: id_zona,
                id_acti: id_acti,
                id_tarea: id_tarea,
                ...item
            }
        },

        async registrarPeligros(item) {
            let newMatrizRef = db.collection("matriz_riesgo").doc();
            let id_matriz = newMatrizRef.id;
            await db.collection("matriz_riesgo").doc(id_matriz).set({
                em_aceptabilidad: item.aceptabilidad,
                em_actividad: item.actividades,
                em_antecedente: item.em_antecedente,
                em_c_fuente: item.control_fuente,
                em_c_individuo: item.control_individuo,
                em_c_medio: item.control_medio,
                em_clasificacion: item.clasificacion,
                em_control_ingenieria: item.controles_ing,
                em_controles_admin: item.controles,
                em_descripcion: item.descripcion,
                em_efecto_posible: item.efectos,
                em_eliminacion: item.eliminacion,
                em_epp: item.equipos,
                em_fecha_editado: firebase.firestore.FieldValue.serverTimestamp(),
                em_fecha_registro: firebase.firestore.FieldValue.serverTimestamp(),

                em_id_acti: item.id_acti,
                em_id_cliente: this.$store.state.msp_c_key,
                em_id_cliente_iper: this.$store.state.msp_c_key_cliente_iper,
                em_id_efectos_posibles: item.id_efectos_posibles,
                em_id_peligro: item.id_peligro,
                em_id_proceso: item.id_proceso,
                em_id_subclasificacion: item.id_subcla,
                em_id_tareas: item.id_tarea,
                em_id_zona: item.id_zona,

                em_interpretacion: item.interpretacion,
                em_interpretacion_nr: item.interpretacion_nr,
                em_nivel_consecuencia: item.nivel_consecuencia,
                em_nivel_eficiencia: item.nivel_eficiencia,
                em_nivel_exposicion: item.nivel_exposicion,
                em_nivel_probabilidad: item.nivel_probabilidad,
                em_nivel_riesgo: item.nivel_riesgo,
                em_num_expuestos: item.num_expuestos,
                em_peor_consecuencia: item.peor_consecuencia,
                em_proceso: item.proceso_riesgo,
                em_rutinario: item.rutinario,
                em_sustitucion: item.sustitucion,
                em_tarea: item.tareas,
                em_tipo: item.tipo,
                em_zona: item.zona,
            });
        },

        async registrarControlCambio(id) {
            let q = "cliente_empresa/" + id + "/controlcambios";
            let refControlCambios = db.collection(q).doc();
            this.controlCambioMatriz.controlCambios.idControlCambio = refControlCambios.id;
            await db.collection(q).doc(this.controlCambioMatriz.controlCambios.idControlCambio).set(this.controlCambioMatriz)
        }
    }
}
</script>

<style scoped></style>